import { useMemo } from 'react';
import {
  CardShipmentItemPayload,
  CardShipmentStatus,
  CardShipmentStatusType,
  useQuery,
} from '@common-fe/common-fe';
import dayjs from 'dayjs';

import { api } from '@/api';
import { PATHS } from '@/common';
import { RAW_DATE_FORMAT } from '@/common/constants';

interface Params {
  id?: string;
}
interface ResponseEvent {
  date: string;
  status: CardShipmentStatus;
  displayed_status_name?: string;
  status_type?: CardShipmentStatusType;
}
interface Response {
  card_id: number;
  events: ResponseEvent[];
}

export const QUERY_KEY = 'GET_SHIPMENT_TRACKER';

const IGNORE_STATUSES: CardShipmentStatus[] = [CardShipmentStatus.CreatedDate, CardShipmentStatus.PrintDate];

const useCardShipmentTrackerQuery = ({ id }: Params) => {
  const { data, isLoading, isSuccess } = useQuery(
    [QUERY_KEY, id],
    () => api.get<Response>(PATHS.CARD_SHIPMENT_BY_ID(id || '')),
    {
      enabled: !!id,
    }
  );

  const formattedList = useMemo(() => {
    const dataList = data?.data?.events || [];
    const filteredList = dataList.filter((item) => !IGNORE_STATUSES.includes(item.status)).reverse();
    // const sorted = _.sortBy(filteredList, (a) =>
    //   STATUSES_ORDER.findIndex((statusItem) => statusItem === (a.status as CardShipmentStatus))
    // );

    const damagedStatusIndex = filteredList.findIndex((item) => item.status === CardShipmentStatus.Damaged);

    const cleared = filteredList.filter((item, index) =>
      damagedStatusIndex == -1 ? true : index <= damagedStatusIndex
    );
    const list: CardShipmentItemPayload[] = cleared.map((item) => {
      const formattedItem: CardShipmentItemPayload = {
        status: item.status,
        name: item.displayed_status_name,
        statusType: item.status_type,
        date: dayjs(item.date, RAW_DATE_FORMAT).toDate(),
      };
      return formattedItem;
    });
    return list;
  }, [data?.data]);

  return {
    isLoading,
    isSuccess,
    data: formattedList,
  };
};

export default useCardShipmentTrackerQuery;
